import React, {Component, Fragment} from 'react';
import {Card, CardBody, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ReactTableTextFilter from '../../../../components/ReactTableTextFilter';
import ReactTableSelectFilter from "../../../../components/ReactTableSelectFilter";
import {getStatusColor, mapStatus} from "../../../../helpers/Utils";
import {keyBy, mapValues, omit} from 'lodash';
import Api from '../../../../services/Api';
import {Link} from "react-router-dom";
import ReactTable from 'react-table';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      payIds: [],
      pages: -1,
      loading: false,
    };
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/deposits/paymentIds',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
          },
        },
      );
      this.setState({
        payIds: data.rows,
        pages: Math.ceil(data.count / state.pageSize),
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'SUBMITTED', label: t('Submitted')},
      {value: 'VERIFIED', label: t('Verified')},
      {value: 'REJECTED', label: t('Rejected')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }


  getColumns = t => [
    {
      Header: t('Id'),
      accessor: 'payId',
      filterable: true,
      Filter: ReactTableTextFilter,
      width: 150,
    },
    {
      Header: t('Iban'),
      accessor: 'sourceIbans',
      Cell: props => <span>{props.value[0]}</span>,
    },
    {
      Header: t('First Name'),
      accessor: 'user.firstName',
      Cell: props => <span>{props.value}</span>
    },
    {
      Header: t('Last Name'),
      accessor: 'user.lastName',
      Cell: props => <span>{props.value}</span>,
    },
    {
      Header: t('Email'),
      accessor: 'user.email',
      width: 160,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      Filter: this.renderStatusFilter,
      Cell: props => <span className={getStatusColor(props.value)}>{mapStatus(props.value)}</span>,
      width: 140,
    },
    {
      Header: t('View'),
      width: 80,
      accessor: 'user.id',
      Cell: props => <Link to={{pathname: '/dashboard/users/' + props.value}}>
        <i className="simple-icon-eye view-icon"/>
      </Link>,
    },
  ];

  render() {
    const {t, match} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={this.state.payIds}
                  pages={this.state.pages}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  defaultPageSize={25}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
